import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { BreadcrumbModel, QueovalParam, AgendaModel, SelectAgenda, DayDisplay, RdvDisplay, BObjectModel, DynamicGroup, BreadDik } from '../../models';
import { ModalService } from '../../modal';
import { ToastService } from '../../toast';
import { CoreService, HttpService, QueovalDateService } from '../../services';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-agenda-affiche',
  templateUrl: './affiche.component.html',
  styleUrls: ['./affiche.component.css']
})
// Affiche la grille du calendrier
export class AfficheComponent implements OnInit, AfterViewInit {
  private dynamicGroup: DynamicGroup;

  public BOModel: BObjectModel;
  public selectEvt: boolean;
  public selectDay: boolean = false;
  public tablette: boolean;
  public mobile: boolean;
  public daySelected: number;
  public dayNumberSelected: number;
  public rdvSelected: RdvDisplay[];
  public dtAgenda: AgendaModel;

  private parentList: RdvDisplay[];
  private elementDragged: RdvDisplay;
  private dragMode: string;

  private maxContainerSize: number = 0;
  public displayPopover: boolean = true;

  @ViewChild('data', { static: false }) data: ElementRef;
  @ViewChild('modal', { static: false }) modal: ElementRef;

  @Output() reloadAgenda: EventEmitter<string> = new EventEmitter<string>();
  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();

  @Input() type: string;
  @Input()
  set DtAgenda(AG: AgendaModel) {
    if (AG) {
      this.dtAgenda = AG;
      this.ngAfterViewInit();
      this.CalculmaxContainerSize();
    }

    const headerWeek: HTMLElement = document.getElementsByClassName('event-header')[0] as HTMLElement;
    if (headerWeek) {
      headerWeek.style.height = this.maxContainerSize > 35 ? '24px' : '34px';
      const calendar: HTMLElement = document.getElementsByClassName('calendar')[0] as HTMLElement;
      if (calendar) {
        calendar.style.height = 'calc(100vh - 235px)';
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(e?: Event): void {
    this.tablette = window.innerWidth <= 1200 && window.innerWidth > 768 ? true : false;
    this.mobile = window.innerWidth <= 768 ? true : false;
  }


  constructor(
    protected modalservice: ModalService,
    protected toastService: ToastService,
    protected indParam: CoreService,
    private httpService: HttpService,
    protected qdate: QueovalDateService
  ) { }


  ngOnInit(): void {
    this.selectEvt = false;
    this.dtAgenda = new AgendaModel();
    this.dtAgenda.ListHour = [''];
    this.BOModel = new BObjectModel;
    this.tablette = window.innerWidth <= 1200 && window.innerWidth > 768 ? true : false;
    this.mobile = window.innerWidth <= 768 ? true : false;
  }
  ngAfterViewInit(): void {
    const beginAgenda: number = this.dtAgenda.BeginWorkAgenda ? this.dtAgenda.BeginWorkAgenda : 5;
    const scroolWeek: any = document.getElementsByClassName('TITM');
    if (scroolWeek && scroolWeek.length > 0) {
      scroolWeek[0].scrollTop = (document.getElementsByClassName('TITM')[0].scrollHeight / 24 * beginAgenda) - 7;
    }
  }
  // #region FONCTIONS PUBLIQUES

  public ShowHideDailyEvents(): void {

    const container: HTMLElement = document.getElementsByClassName('event-header')[0] as HTMLElement;
    if (container) {
      if (container.style.height === `${this.maxContainerSize}px`) {
        container.style.height = this.maxContainerSize > 35 ? '24px' : '34px';
        const calendar: HTMLElement = document.getElementsByClassName('calendar')[0] as HTMLElement;
        if (calendar) {
          calendar.style.height = 'calc(100vh - 260px)';
        }
      }
      else {
        container.style.height = `${this.maxContainerSize}px`;
        const calendar: HTMLElement = document.getElementsByClassName('calendar')[0] as HTMLElement;
        if (calendar) {
          const h: number = 235 + this.maxContainerSize
          calendar.style.height = `calc(100vh - ${h}px)`;
        }
      }
    }
  }
  // Récupere le type d'évenement
  public getCode(selmodel: string): void {
    let modeAffiche: string = '';
    this.dtAgenda.ListAgenda.forEach((e: SelectAgenda) => {
      if (e.Code === selmodel) {
        this.closeSelectEvt();
        this.BOModel = e.BOModel;
        this.BOModel.ClientData = this.dynamicGroup;
        modeAffiche = e.ModeAffiche;
      }
    });
    // Fermeture de la modale depuis laquelle est appelé cette fonction
    this.modalservice.close('modalEvent');
    this.addEvent(modeAffiche);
  }

  // ouvrir un evenement en modification
  public openEvent(event: any, selevent: BObjectModel, modeAffiche: string): void {
    event.stopPropagation();
    if (modeAffiche !== 'NOOPEN') {
      this.BOModel = selevent;
      this.addEvent(modeAffiche);
    }
  }

  // ouvre la fenetre de selection type event
  public openSelectEvt(): void {
    const sel: SelectAgenda[] = this.dtAgenda.ListAgenda.filter((e: SelectAgenda) => e.Check);
    if (!sel || sel.length === 0) {
      this.toastService.showAlertToast('check one of the left check box');
      return;
    }

    this.dtAgenda.ListAgenda.forEach((e: SelectAgenda) => {
      if (!this.selectDay) {
        if (e.Ecriture) {
          this.modalservice.open('modalEvent');
        }
      } else {
        this.modalservice.open('selectDay');
      }
    });
  }

  // ferme la fenetre du bo
  public closeModal(): void {
    // actualise l'agenda
    this.reloadAgenda.emit('N');
  }

  // ferme la fenetre de selection du type event
  public closeSelectEvt(): void {
    this.selectEvt = false;
  }

  public selectEventsDay(Day?: DayDisplay): void {
    if (Day !== undefined) {
      const date: Date = new Date(Day.Date);
      this.daySelected = date.getDay();
      this.dayNumberSelected = date.getDate();
      this.rdvSelected = Day.ListRdv;
    }
    this.selectEvt = false;
    this.selectDay = !this.selectDay;
  }

  public onNewEventDay(Day: DayDisplay, Hour?: string): void {
    // permet de mettre une zone grise a l'endroit de l'evenement
    const date: Date = new Date(Day.Date);
    const day: string = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
    const month: string = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    this.dynamicGroup = new DynamicGroup;
    this.dynamicGroup.Date = Hour !== undefined ? `${day}/${month}/${date.getFullYear()}/${Hour.split('h')[0]}` : `${day}/${month}/${date.getFullYear()}/00`;
    this.openSelectEvt();
  }

  // #endregion

  // #region FONCTIONS PRIVEES
  // recupere l'évent et crée un nouveau breadcrump à partir de celui ci
  // pour renvoyer les infos à l'agendaComponent
  private addEvent(modeAffiche: string): void {
    const params: Array<BreadDik> = new Array<BreadDik>();
    let param: QueovalParam = { params, model: this.BOModel };
    let breadCrumbItem: BreadcrumbModel = new BreadcrumbModel('add', '', param, '', true);

    switch (modeAffiche) {
      case 'RESA':
        if (this.BOModel.CodeRelation !== 'REL_BO_CNX_BO_RESERV') {
          this.toastService.showWarningToast(`Uncorrect Relation ${this.BOModel.CodeRelation}`);
        } else {
          params.push(new BreadDik('code', 'RESA'));
          param = { params, model: this.BOModel };
          breadCrumbItem = new BreadcrumbModel('add', 'reservation', param, 'Réservation', true);
        }
        break;

      case 'RESASTG':
        params.push(new BreadDik('code', 'RESASTG'));
        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'reservationstagiaire', param, 'Réservation-apprenant', true);
        break;

      case 'RESAFORM':
        params.push(new BreadDik('code', 'RESAFORM'));
        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'reservationformateur', param, 'Réservation-formateur', true);
        break;

      case 'RDV':
        params.push(new BreadDik('code', 'RDV'));
        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'rendezvous', param, 'Rendez-vous', true);
        break;

      case 'CONGES':
        let strdt: string = '';
        if (this.BOModel.ClientData) {
          const dt: Array<string> = this.BOModel.ClientData.Date.split('/');

          if (dt.length >= 3) {
            strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%2000:00&`;
          }
        }
        //params.push(new BreadDik('src', `${this.indParam.ConfigFile.appUrl}RH/PageConge.aspx?${strdt}Collaborateur=${this.BOModel.IdDonneePere}`));
        params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}RH/PageConge.aspx?${strdt}Collaborateur=${this.BOModel.IdDonneePere}`));

        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'conges', param, 'Congés', false);
        break;

      case 'TACHES':
        if (this.BOModel.ClientData) {
          const dt: Array<string> = this.BOModel.ClientData.Date.split('/');
          let strdt: string = '';
          if (dt.length >= 4) {
            strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%20${dt[3]}:00&`;
          }
          //params.push(new BreadDik('src', `${this.indParam.ConfigFile.appUrl}SPEF_COMPTA/PageCreateTacheAffaire.aspx?P1=0&${strdt}IdUser=${this.BOModel.IdDonneePere}`));
          params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}SPEF_COMPTA/PageCreateTacheAffaire.aspx?P1=0&${strdt}IdUser=${this.BOModel.IdDonneePere}`));
        } else {
          params.push(new BreadDik('code', 'TACHES'));
        }
        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'taches', param, 'Taches', false);
        break;

      case 'OBLIGATIONS':
        this.httpService.getHttp<AgendaModel>(`${this.indParam.AppParams.apiUrl}api/agenda/getData/GET_CLIENT_BY_ID_OBLIGATION/${this.BOModel.IdDonneeFils}`).subscribe((result: AgendaModel) => {
          if (result.Mode) {
            //params.push(new BreadDik('src', `${this.indParam.ConfigFile.appUrl}PageAgendaModif.aspx?IdUser=${this.BOModel.IdDonneePere}&Date=&IdDonnee=${this.BOModel.IdDonneeFils}&IdRelation=${this.BOModel.IdRelation}&NoModif=False&AllDay=0&IDCLIENT=${result.Mode}`));
            params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}PageAgendaModif.aspx?IdUser=${this.BOModel.IdDonneePere}&Date=&IdDonnee=${this.BOModel.IdDonneeFils}&IdRelation=${this.BOModel.IdRelation}&NoModif=False&AllDay=0&IDCLIENT=${result.Mode}`));
            param = { params, model: this.BOModel };
            breadCrumbItem = new BreadcrumbModel('add', 'taches', param, 'Obligations', false);
            this.sendBreadcrumb.emit(breadCrumbItem);
          }
        });
        break;

      case 'ACTION_CO':
        params.push(new BreadDik('code', 'ACTION_CO'));
        if (this.BOModel.ClientData) {
          const dt: Array<string> = this.BOModel.ClientData.Date.split('/');
          let strdt: string = '';
          let strIdPersonne: string = '';
          if (dt.length >= 4) {
            strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%20${dt[3]}:00&`;
          }
          if (this.BOModel.IdDonneePere) {
            strIdPersonne = `IdDonnee=${this.BOModel.IdDonneePere}&`;
          }
          //params.push(new BreadDik('src', `${this.indParam.ConfigFile.appUrl}GRC/PageNewAction.aspx?${strdt}${strIdPersonne}IDCLIENT=`));
          params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}GRC/PageNewAction.aspx?${strdt}${strIdPersonne}IDCLIENT=`));
        } else {
          //params.push(new BreadDik('src', `${this.indParam.ConfigFile.appUrl}GRC/PageAction.aspx?IDDONNEE=${this.BOModel.IdDonneeFils}`));
          params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}GRC/PageAction.aspx?IDDONNEE=${this.BOModel.IdDonneeFils}`));
        }
        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'actionCo', param, 'Action Commerciale', false);
        break;
      default:
        param = { params, model: this.BOModel };
        breadCrumbItem = new BreadcrumbModel('add', 'rendezvousformateur', param, 'Rendez-vous', true);
        break;
    }
    // this calls agenda.component.ts "getBreadcrumb" method (line 176)
    if (modeAffiche !== 'OBLIGATIONS') {
      this.sendBreadcrumb.emit(breadCrumbItem);
    }
  }
  // #endregion

  // #region Useless méthodes


  // methodes non implémenté pour l'instant
  public allowDrop(ev: any, mode: string): void {
    if (!this.dragMode || this.dragMode === mode) {
      ev.preventDefault();
      this.displayPopover = true;
    }
  }

//#region drag & drop

  //public allowDropSlot(ev: any, mode: string, classDrop: string): void {
  //  if ((!this.dragMode || this.dragMode === mode) && ev.target.classList.contains(classDrop)) {
  //    ev.preventDefault();
  //    this.displayPopover = true;
  //  }
  //}

  //public drag(ev: any, value: any): void {
  //  ev.dataTransfer.setData('text', ev.target.id);
  //}

  //public dragEvent(ev: any, value: any, parentList: RdvDisplay[], mode: string): void {
  //  this.displayPopover = false;
  //  const i = parentList.indexOf(value);
  //  this.elementDragged = value;
  //  this.parentList = parentList;

  //  this.dragMode = mode;
  //  ev.dataTransfer.setData('indexElement', i);
  //  ev.dataTransfer.setData('pere', `${value.BOModel.IdDonneePere}`);
  //  ev.dataTransfer.setData('fils', `${value.BOModel.IdDonneeFils}`);
  //  ev.dataTransfer.setData('relation', `${value.BOModel.IdRelation}`);
  //}

  //public dragEventSlot(ev: any, value: any, dayIndex: RdvDisplay[], mode: string): void {
  //  this.displayPopover = false;
  //  this.elementDragged = value;

  //  this.dragMode = mode;
  //  ev.dataTransfer.setData('dayIndex', dayIndex);
  //  ev.dataTransfer.setData('pere', `${value.BOModel.IdDonneePere}`);
  //  ev.dataTransfer.setData('fils', `${value.BOModel.IdDonneeFils}`);
  //  ev.dataTransfer.setData('relation', `${value.BOModel.IdRelation}`);
  //}


  //public onDropDay(e: any, day: DayDisplay, heure: string, indexHeure: number): void {
  //  //#region construction du model
  //  const model: EventsModel = new EventsModel();
  //  model.UpdateDate = new UpdateDate();
  //  model.Mode = 'UPDATE_DATE';
  //  model.UpdateDate.idPere = e.dataTransfer.getData('pere');
  //  model.UpdateDate.idFils = e.dataTransfer.getData('fils');
  //  model.UpdateDate.idRelation = e.dataTransfer.getData('relation');
  //  model.UpdateDate.dateDebut = this.qdate.FromDate(new Date(day.Date));

  //  model.UpdateDate.heureDebut = Number.parseInt(heure.split('h')[0]);
  //  model.UpdateDate.minDebut = Number.parseInt(heure.split('h')[1]);
  //  //#endregion

  //  let options: any = {
  //    year: 'numeric', month: 'short', day: 'numeric'
  //  };

  //  const dt: Date = new Date(Number.parseInt(model.UpdateDate.dateDebut.annee), Number.parseInt(model.UpdateDate.dateDebut.mois), Number.parseInt(model.UpdateDate.dateDebut.jour), model.UpdateDate.heureDebut, model.UpdateDate.minDebut);
  //  const newDateDebut: string = dt.toLocaleString(this.indParam.AppParams.culture, options);
  //  dt.setMinutes(dt.getMinutes() + Number.parseInt(this.elementDragged.height.replace('px', '')) / 12 * 15);
  //  const strHours: string = dt.getHours() < 10 ? `0${dt.getHours()}` : `${dt.getHours()}`
  //  const strMins: string = dt.getMinutes() < 10 ? `0${dt.getMinutes()}` : `${dt.getMinutes()}`
  //  this.elementDragged.Info = `${newDateDebut} - ${heure.split('h')[0]}:${heure.split('h')[1]} - ${strHours}:${strMins}`;

  //  this.elementDragged.top = (model.UpdateDate.minDebut * 48 / 60) + indexHeure * 48 + 'px';
  //  day.ListRdvonDay.push(this.elementDragged);

  //  this.parentList.splice(e.dataTransfer.getData('indexElement'), 1);
  //  this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe(
  //    (result: EventsModel) => {
  //    })
  //}

  //public onDropSlots(e: any, day: DayDisplay, parentIndex: number, parentList: DayDisplay[]): void {
  //  //#region construction du model
  //  const model: EventsModel = new EventsModel();
  //  model.UpdateDate = new UpdateDate();
  //  model.Mode = 'UPDATE_DATE';
  //  model.UpdateDate.idPere = e.dataTransfer.getData('pere');
  //  model.UpdateDate.idFils = e.dataTransfer.getData('fils');
  //  model.UpdateDate.idRelation = e.dataTransfer.getData('relation');
  //  model.UpdateDate.dateDebut = this.qdate.FromDate(new Date(day.Date));

  //  model.UpdateDate.heureDebut = -1;
  //  model.UpdateDate.minDebut = -1;
  //  //#endregion
  
  //  this.elementDragged.top = (day.ListRdv.findIndex(e => e.Ident === this.elementDragged.Ident) === -1 ? day.ListRdv.length : day.ListRdv.length - 1) + 'em';

  //  let eventSize: number = 0;
  //  parentList.forEach((day: DayDisplay) => {
  //    eventSize = day.ListRdv.findIndex((e: RdvDisplay) => e.Ident === this.elementDragged.Ident) === -1 ? eventSize : eventSize + 1;
  //  });

  //  let options: any = {
  //    year: 'numeric', month: 'short', day: 'numeric'
  //  };
  //  const dt: Date = new Date(Number.parseInt(model.UpdateDate.dateDebut.annee), Number.parseInt(model.UpdateDate.dateDebut.mois), Number.parseInt(model.UpdateDate.dateDebut.jour))
  //  const newDateDebut: string = dt.toLocaleString(this.indParam.AppParams.culture, options);
  //  dt.setDate(dt.getDate() + eventSize - 1);
  //  const newDateFin: string = dt.toLocaleString(this.indParam.AppParams.culture, options);
  //  this.elementDragged.Info = `${newDateDebut} - ${newDateFin}`;

  //  let maxLoop = eventSize + Number.parseInt(e.dataTransfer.getData('dayIndex')) > parentList.length ? parentList.length : eventSize + Number.parseInt(e.dataTransfer.getData('dayIndex'))
  //  for (let i: number = Number.parseInt(e.dataTransfer.getData('dayIndex')); i < maxLoop; i++) {
  //    const idRdv: number = parentList[i].ListRdv.findIndex(e => e.Ident === this.elementDragged.Ident);
  //    if (idRdv != -1) {
  //      parentList[i].ListRdv.splice(idRdv, 1)
  //    }
  //  }

  //  maxLoop = eventSize + parentIndex > parentList.length ? parentList.length : eventSize + parentIndex
  //  for (let i: number = parentIndex; i < maxLoop; i++) {
  //    if (i !== parentIndex) {
  //      this.elementDragged.classDisplay = 'g3dbUc PU9jSd UflSff jKgTF QGRmIf';
  //    }
  //    this.elementDragged.left = i * 100 / this.dtAgenda.ListDay.length + '%';
  //    parentList[i].ListRdv.push(JSON.parse(JSON.stringify(this.elementDragged)));
  //  }

  //  this.CalculmaxContainerSize();
  //  const container: HTMLElement = document.getElementsByClassName('event-header')[0] as HTMLElement;
  //  if (container) {
  //    container.style.height = `${this.maxContainerSize}px`;
  //    const calendar: HTMLElement = document.getElementsByClassName('calendar')[0] as HTMLElement;
  //    if (calendar) {
  //      const h: number = 235 + this.maxContainerSize
  //      calendar.style.height = `calc(100vh - ${h}px)`;
  //    }
  //  }

  //  this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe(
  //    (result: EventsModel) => {
  //    })
  //}

  //public onDropMonth(e: any, day: DayDisplay, parentIndex: number, parentList: DayDisplay[]): void {
  //  const model: EventsModel = new EventsModel();
  //  model.UpdateDate = new UpdateDate();
  //  model.Mode = 'UPDATE_DATE';
  //  model.UpdateDate.idPere = e.dataTransfer.getData('pere');
  //  model.UpdateDate.idFils = e.dataTransfer.getData('fils');
  //  model.UpdateDate.idRelation = e.dataTransfer.getData('relation');
  //  model.UpdateDate.dateDebut = this.qdate.FromDate(new Date(day.Date));


  //  model.UpdateDate.heureDebut = -1;
  //  model.UpdateDate.minDebut = -1;
  //  let options: any = {
  //    year: 'numeric', month: 'short', day: 'numeric'
  //  };

  //  console.log(new Date(Number.parseInt(model.UpdateDate.dateDebut.annee), Number.parseInt(model.UpdateDate.dateDebut.mois), Number.parseInt(model.UpdateDate.dateDebut.jour)).toLocaleString(this.indParam.AppParams.culture, options));

  //  this.elementDragged.left = parentIndex * 100 / parentList.length + '%';
  //  this.elementDragged.classDisplay = parentList[parentIndex].ListRdv.length > 3 ? 'g3dbUc PU9jSd UflSff jKgTF QGRmIf' : this.elementDragged.classDisplay;

  //  this.elementDragged.top = (parentList[parentIndex].ListRdv.findIndex(e => e.Ident === this.elementDragged.Ident) === -1 ? parentList[parentIndex].ListRdv.length : parentList[parentIndex].ListRdv.length - 1) + 'em';
  //  parentList[parentIndex].ListRdv.push(this.elementDragged);

  //  this.parentList.splice(e.dataTransfer.getData('indexElement'), 1);
  //  this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe(
  //    (result: EventsModel) => {
  //    })
  //}
  //// permet de mettre une zone grise a l'endroit de l'evenement
  //public onNewEventWeek(Day: DayDisplay, Index: number): void {
  //  this.openSelectEvt();
  //}
//#endregion

  private CalculmaxContainerSize(): void {
    this.maxContainerSize = 0;
    this.dtAgenda.ListDay.forEach((day: DayDisplay) => {
      let currentContainerSize: number = 10;
      day.ListRdv.forEach(() => {
        currentContainerSize += 25;
      });
      this.maxContainerSize = this.maxContainerSize > currentContainerSize ? this.maxContainerSize : currentContainerSize;
    });
  }
  // #endregion
}
